import { DocReference } from '@dadohr/shared/domainTypes/document';
import { FS } from '@dadohr/shared/versions';
import { useCollection } from 'react-firebase-hooks/firestore';
import { store, useMappedLoadingValue } from '../../../services/firebase';
import { toAuditLogEntryDoc } from './documents';

export const useAuditLogForDoc = (docRef: DocReference, limit = 30) => {
  return useMappedLoadingValue(
    useCollection(
      store()
        .collection(FS.auditLog)
        .where('doc.collection', '==', docRef.collection)
        .where('doc.id', '==', docRef.id)
        .orderBy('at', 'desc')
        .limit(limit)
    ),
    (s) => {
      return s.docs.map(toAuditLogEntryDoc);
    }
  );
};
